import React from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;

export const ZoneForm = ({ form, onFinish }) => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>      <Form.Item
        name="name"
        label="Nom de la contrat"
        rules={[{ required: true, message: "Veuillez entrer un nom de contrat" }]}
      >
        <Input placeholder="Entrer le nom de la contrat" />
      </Form.Item>

      <Form.Item
        name="prefix"
        label="Préfixe"
        rules={[
          { required: true, message: "Veuillez entrer un préfixe" },
          { max: 10, message: "Le préfixe ne peut pas dépasser 10 caractères" }
        ]}
      >
        <Input placeholder="Entrer le préfixe (max 10 caractères)" maxLength={10} />
      </Form.Item>

      <Form.Item name="description" label="Description">
        <TextArea placeholder="Entrer la description de la contrat" rows={4} />
      </Form.Item>
    </Form>
  );
};
